<template>
  <div>
    <v-dialog :value="isOpen" @input="close" max-width="600" v-if="isOpen">
      <v-card class="iframe-wrapper">
        <iframe
          title="email"
          scrolling="no"
          ref="iframe"
          frameBorder="0"
          height="700"
          :src="iframeSrc"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const IFRAME_CHANGE_EMAIL_VIEW_MESSAGE = "closeChangeEmailView";

export default {
  name: "ChangeEmailDialog",
  props: {
    isOpen: Boolean
  },
  created() {
    window.addEventListener("message", this.onMessage);
  },
  data() {
    return {
      iframeSrc: `${process.env.VUE_APP_AUTH_URL}/email/change`
    };
  },
  methods: {
    onMessage({ data: message }) {
      if (message === IFRAME_CHANGE_EMAIL_VIEW_MESSAGE) {
        this.close();
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
